import { dayParts } from "./dayParts.ts";
import type { TZ } from "./timezone.ts";
import type { TranslatedString } from "./types.ts";

/** Shared browser/Node formatter. Keep runtime imports Node-safe: use explicit .ts paths
 * and do not load date-fns-tz here. The full browser API re-exports this implementation.
 */
export function formatISODate(date: Date, timeZone?: TZ): TranslatedString {
  const { year, month, day } = dayParts(date, timeZone);
  return `${year}-${month}-${day}` as TranslatedString;
}
